import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TimesheetCalendarSourceType } from 'api/timesheets';
import { CalendarIntegration } from 'api/timesheets/integration/calendar-integration-provider';
import { Button } from 'components/atoms/button';
import { ProductiveHeading06 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';
import { useTimesheetIntegrationOauthQuery } from 'queries/timesheets/calendar-integration-provider';

interface Props {
  sourceType: TimesheetCalendarSourceType;
  expiredIntegration: CalendarIntegration;
}

const Wrapper = styled.div`
  height: 258px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 var(--spacing-09);
  align-items: flex-start;
`;

const Content = styled.div`
  margin-top: var(--spacing-05);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);

  ${Button} {
    padding-left: 0px;
  }
`;

const Title = styled.div`
  ${ProductiveHeading06};
`;

const StyledLink = styled(Typography.Link)`
  padding-left: var(--spacing-02);
`;

const Description = styled.div``;

export const ReAuthCalendar: FC<Props> = ({ sourceType }) => {
  const frontendRedirectPath = window.location.pathname;

  const { data: authMeta, isLoading } = useTimesheetIntegrationOauthQuery(
    sourceType,
    frontendRedirectPath,
  );
  const alertMessage = useTranslation('integration.alert.error.message');
  const reAuthMessage = useTranslation(
    'ai_fill.calendar_integration_expired.description',
  );
  const reAuthenticate = useTranslation(
    'settings.integration.alert.button.message',
  );

  return (
    <Wrapper>
      <FontAwesomeIcon size="3x" icon={faExclamationCircle} />
      <Content>
        <Title>{alertMessage}</Title>
        <Description>{reAuthMessage}</Description>
        <Button type="link" href={authMeta?.oauthReauthUrl} loading={isLoading}>
          <StyledLink>{reAuthenticate}</StyledLink>
        </Button>
      </Content>
    </Wrapper>
  );
};
